import {
  ACTION_STATUS_TYPE,
  AUDIT_LOG_TARGET_TYPES,
  IAuditLog,
  IAuditLogChange,
  IAuditLogLeafChange,
  IAuthAuditLog,
  IAuthAuditLogData,
  LOG_OPERATION_TYPE,
} from 'api/auditLogs/types';
import { TObject } from 'utils/types';

export function normalizeAuditLogs(data: TObject): IAuditLog {
  let changes = {};
  try {
    changes = JSON.parse(data?.changes as string) || {};
  } catch {
    // eslint-disable-next-line no-console
    console.warn('Error of parsing changes for audit log with id: ', data?.uuid);
  }

  return {
    authorId: (data?.authorId as string) || '',
    authorLogin: (data?.authorLogin as string) || '',
    changes,
    creationDate: (data?.creationDate as string) || '',
    operationType: (data?.operationType as LOG_OPERATION_TYPE) || '',
    parentId: (data?.parentId as string) || '',
    parentType: (data?.parentType as AUDIT_LOG_TARGET_TYPES) || '',
    targetId: (data?.targetId as string) || '',
    targetType: (data?.targetType as AUDIT_LOG_TARGET_TYPES) || '',
    uuid: (data?.uuid as string) || '',
  };
}

const flattenAuditLogChange = (
  change: IAuditLogChange,
  path: string[],
): IAuditLogLeafChange[] => {
  if (!change.changeType) {
    return Object.entries(change).flatMap(([key, nested]) =>
      flattenAuditLogChange(nested as IAuditLogChange, [...path, key]),
    );
  }

  if (change.elements) {
    return change.elements.flatMap((element) => flattenAuditLogChange(element, path));
  }

  return [{ change, path }];
};

// Nested lists (list → row id → field) and element arrays expand to one entry per rendered row.
export function flattenAuditLogChanges(
  changes: IAuditLog['changes'],
): IAuditLogLeafChange[] {
  return Object.entries(changes).flatMap(([key, change]) =>
    flattenAuditLogChange(change, [key]),
  );
}

export function normalizeAuthAuditLogs(data: IAuthAuditLogData): IAuthAuditLog {
  return {
    actionStatus: (data?.actionStatus as ACTION_STATUS_TYPE) || '',
    actionType: (data?.actionType as string) || '',
    additionalInfo: (data?.additionalInfo as string) || '',
    created: (data?.created as string) || '',
    id: (data?.id as string) || '',
    ip: (data?.ip as string) || '',
    login: (data?.login as string) || '',
    user: {
      id: (data?.user?.id as string) || '',
    },
    userAgent: (data?.userAgent as string) || '',
  };
}
